export const dataSendToAndroid = (data) => {
    console.log(
      "Sending data to Android/iOS and other React app:",
     typeof(data) 
    );
    if (window.androidObj) {
      if (data === "groupcall") {
        window.androidObj.groupCall(data);
      } else {
        window.androidObj.readId(data);
      }
    }
    if (data === "groupcall") {
      if (window.webkit && window.webkit.messageHandlers.groupCall) {
        window.webkit.messageHandlers.groupCall.postMessage(data);
      }
    } else {
      if (window.webkit && window.webkit.messageHandlers.readId) {
        window.webkit.messageHandlers.readId.postMessage(data);
      }
    }
    if (data === "groupcall") {

    window.parent.postMessage(
      { type: "dataReceivedFromReact", payload:  data },
      "*"
    );
  }
  else
  {
    window.parent.postMessage(
      { type: "dataReceivedFromReact", payload:  data },
      "*"
    );
  }
  };
  